<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
	components: {
		VuePerfectScrollbar,
	},
	props: {
		user: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		isMenuOpened: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {}
	},
	computed: {
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},
	methods: {
		toggleMenu() {
			this.$parent.toggleMenu()
		},
		toggleRightSidebar() {
			this.$parent.toggleRightSidebar()
		},
	},
}
</script>

<template>
	<div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
		<div class="container-fluid">
			<a href="/" class="navbar-brand mr-0 mr-md-2 logo">
				<span class="logo-lg">
                    <h3 style="display:flex !important; justify-content:flex-start; align-items:center; text-transform: none;" class="d-inline align-middle ml-1 text-logo">
                        <i class="feather uil uil-chart" style="color: #c38a47; font-size: 26px; margin-right: 10px"></i>
                        <span style="font-size: 20px; margin-right: 5px">BRENDOSS </span> <span style="color: #c38a47; font-size: 20px;">ФИНАНС</span>
                    </h3>
				</span>
				<span class="logo-sm">
                    <h3 style="display:flex !important; justify-content:flex-start; align-items:center; text-transform: none;" class="d-inline align-middle ml-1 text-logo">
                        <i class="feather uil uil-chart" style="color: #c38a47; font-size: 26px; margin-right: 10px"></i>
                        <span style="font-size: 20px; margin-right: 5px">BRENDOSS </span> <span style="color: #c38a47; font-size: 20px;">ФИНАНС</span>
                    </h3>
				</span>
			</a>
			<ul class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0">
				<li class>
					<button
						class="button-menu-mobile open-left disable-btn"
						:class="{ open: isMenuOpened }"
						@click="toggleMenu"
					>
						<feather type="menu" class="menu-icon align-middle"></feather>
						<feather type="x" class="close-icon"></feather>
					</button>
				</li>
			</ul>

            <ul
                class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0"
            >
                <!-- <b-nav-item
                    to="/account/finance/payin"
                >
                    <span class="col" style="margin-top: 10px; height: 100%">
                        <i class="feather uil uil-wallet" style="font-size: 16px"></i>
                    </span>
                    <span class="col" style="padding: 0px">
                        <span>{{this.session_user_item.balance ? this.session_user_item.balance + ' руб.' : '0.00 руб.'}}</span>
                    </span>
                </b-nav-item> -->

                <!--
                <b-nav-item-dropdown
                    id="globe-tooltip"
                    right
                    variant="black"
                    class="dropdown d-none d-lg-block"
                    no-caret
                >
                    <template v-slot:button-content>
                        <feather type="globe"></feather>
                    </template>
                    <b-tooltip target="globe-tooltip" placement="left"
                    >Изменить язык</b-tooltip
                    >
                    <b-dropdown-text href="javascript:void(0);" class="notify-item">
                        <img
                            src="@assets/images/flags/russia.jpg"
                            alt="user-image"
                            class="mr-2"
                            height="12"
                        />
                        <span class="align-middle">Русский</span>
                    </b-dropdown-text>
                </b-nav-item-dropdown>
                -->

                <b-nav-item-dropdown
                    id="bell-notification"
                    right
                    variant="white"
                    class="notification-list"
                    title="новые уведомления"
                    menu-class="dropdown-lg"
                >
                    <template v-slot:button-content>
                        <i class="feather uil uil-bell" style="font-size: 16px"></i>
                    </template>
                    <b-tooltip target="bell-notification" placement="left"
                    >Новых уведомлений нет</b-tooltip
                    >
                    <!-- item-->
                    <b-dropdown-text class="noti-title border-bottom pb-2" tag="div">
                        <h5 class="m-0 font-size-16">
                                <span class="float-right">
                                    <a href class="text-dark">
                                        <small>Очистить все</small>
                                    </a> </span
                                >Уведомления
                        </h5>
                    </b-dropdown-text>

                    <VuePerfectScrollbar v-once class="noti-scroll">

                        <!-- item
                        <b-dropdown-text
                            href="javascript:void(0);"
                            class="notify-item border-bottom"
                        >
                            <div class="notify-icon bg-primary">
                                <i class="uil uil-user-plus"></i>
                            </div>
                            <p class="notify-details">
                                Активирован новый пользователь.
                                <small class="text-muted">5 часов назад</small>
                            </p>
                        </b-dropdown-text>
                        -->

                    </VuePerfectScrollbar>

                    <!-- All-->
                    <b-dropdown-text
                        href="javascript:void(0);"
                        class="text-center text-primary notify-item notify-all border-top"
                        style="display: none"
                    >
                        View all
                        <i class="fi-arrow-right"></i>
                    </b-dropdown-text>

                </b-nav-item-dropdown>

            </ul>


        </div>
	</div>
</template>


<style lang="scss">
.noti-scroll {
    height: 220px;
}
.ps > .ps__scrollbar-y-rail {
    width: 8px !important;
    background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
    width: 6px !important;
}
.button-menu-mobile {
    outline: none !important;
}

.navbar-custom .topnav-menu .nav-link {
    line-height: 120%;
}

@media (max-width: 1024px) {
    .navbar-custom .logo {
        display: block !important;
        position: absolute;
        left: 86px;

    }
    .navbar-custom .logo img {
        height: 40px !important;
    }
}

@media (max-width: 400px) {
    .navbar-custom .logo {
        display: none !important;
    }
}

</style>
